import {
  GETVOUCHERDETAILS_SUCCESS,
  GETVOUCHERDETAILS_FAILED,
  RESET_GETVOUCHERDETAILS,
  LOADING_GETVOUCHERDETAILS,
  NETWORK_ERROR_GETVOUCHERDETAILS,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetVoucherDetails = () => {
  return { type: RESET_GETVOUCHERDETAILS };
};

const getvoucherDetailsList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETVOUCHERDETAILS });
  await partnerServices
    .post("getVoucherDetails", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(voucherDetailsSuccess(res.data));
          break;
        default:
          dispatch(voucherDetailsFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GETVOUCHERDETAILS,
        payload: err,
      });
    });
};
function voucherDetailsSuccess(data) {
  return {
    type: GETVOUCHERDETAILS_SUCCESS,

    payload: data,
  };
}
function voucherDetailsFailed(data) {
  return {
    type: GETVOUCHERDETAILS_FAILED,
    payload: data,
  };
}

export { resetVoucherDetails, getvoucherDetailsList };
